<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>新建内部发放</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            show-checkbox
            @check="handleCheckChange"
            :filter-node-method="filterNode"
            ref="tree"
          >
          </el-tree>
        </div>
      </div>
      <div class="table_container" style="border: 0 solid rgb(222,222,222);">
        <div style="height: 30px;margin-top: 5px;display: flex;justify-content: space-between">
          <div>
            <span >发放产品总额： </span>
            <el-input style="width: 300px" disabled v-model="purchase.purchaseMoney" size="mini" />
          </div>
        </div>
        <div style="margin-top:5px;text-align: right">
          <el-button size="mini" plain @click="showProductDrawer">添加明细</el-button>
        </div>
        <div style="height: 400px;">
          <el-table :data="selectProductList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                    max-height="400" height="400"
                    :row-style="{height: '0'}">
            <el-table-column
              align="center"
              prop="userName"
              label="操作" width="100">
              <template slot-scope="scope">
                <el-link type="danger" icon="el-icon-delete"
                         @click="deleteConsumptionShowList(scope.$index, selectProductList)"></el-link>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="consumptionName"
              label="产品名称">
            </el-table-column>
            <el-table-column
              align="center"
              label="数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.num" size="mini" @change="getTotal"
                          onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="产品单价">
              <template slot-scope="scope">
                <div v-if="(currentOrgPurchaseLevel-0) === 1">
                  <el-input v-model="scope.row.oneLevelPrice" size="mini" @change="getTotal"
                            onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 2">
                  <el-input v-model="scope.row.twoLevelPrice" size="mini" @change="getTotal"
                            onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 3">
                  <el-input v-model="scope.row.threeLevelPrice" size="mini" @change="getTotal"
                            onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="小计">
              <template slot-scope="scope">
                <div v-if="(currentOrgPurchaseLevel-0) === 1">
                  {{ (scope.row.oneLevelPrice * scope.row.num).toFixed(1) }}
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 2">
                  {{ (scope.row.twoLevelPrice * scope.row.num).toFixed(1)}}
                </div>
                <div v-if="(currentOrgPurchaseLevel-0) === 3">
                  {{ (scope.row.threeLevelPrice * scope.row.num).toFixed(1)}}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-card class="box-card">
          <div>
            <span >备注说明： </span>
            <el-input style="width: 100%" placeholder="请输入内容" v-model="purchase.comment" type="textarea" />
          </div>
        </el-card>
        <span class="dialog-footer">
          <el-button size="mini" @click="closeSendPage">返 回</el-button>
          <el-button size="mini" @click="createSend">确 定</el-button>
        </span>
      </div>
    </div>
    <!-- 选择产品 -->
    <el-drawer
      title="产品列表"
      size="60%"
      :visible.sync="productDrawerVisible"
      :before-close="closeProductDrawer"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div class="between" style="padding: 0 10px">
        <div class="left_con" >
          <div class="left_inner_con">
            <!--            <el-input size="mini"-->
            <!--                      style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"-->
            <!--                      placeholder="输入关键字进行过滤"-->
            <!--                      v-model="consumptionTypeFilterText">-->
            <!--            </el-input>-->
            <el-card class="box-card">
              <el-tree
                :data="consumptionTypeList"
                :props="consumptionTypeProps"
                @node-click="consumptionTypeHandleNodeClick"
                :highlight-current="true"
                node-key="id"
                :filter-node-method="consumptionTypeFilterNode"
                default-expand-all
                ref="serviceTree"
              >
              </el-tree>
            </el-card>
          </div>
        </div>
        <div class="table_container">
          <!--          <el-input size="mini"-->
          <!--                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"-->
          <!--                    placeholder="输入关键字进行过滤"-->
          <!--                    v-model="queryProductText"-->
          <!--                    @keyup.enter.native="queryConsumption"-->
          <!--          >-->
          <!--          </el-input>-->
          <el-card class="box-card">
            <el-table height="550px" :data="consumptionList" fit border stripe="stripe"
                      :header-cell-style="{background:'#eff3f8', color:'#333'}"
                      :row-style="{height: '0'}">
              <el-table-column
                align="center"
                fixed="fixed"
                label="操作" width="160">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.num"
                                   size="mini"
                                   @change="orderNumHandleChange(scope.row)" :min="0" :max="100000" label="描述文字"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="consumptionName"
                fixed="fixed"
                label="服务名称" width="160">
              </el-table-column>
              <el-table-column
                align="center"
                label="发放价格" >
                <template slot-scope="scope">
                  <div v-if="(currentOrgPurchaseLevel-0) === 1">
                    {{scope.row.oneLevelPrice}}
                  </div>
                  <div v-if="(currentOrgPurchaseLevel-0) === 2">
                    {{scope.row.twoLevelPrice}}
                  </div>
                  <div v-if="(currentOrgPurchaseLevel-0) === 3">
                    {{scope.row.threeLevelPrice}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="practicalNum"
                label="库存数量" >
              </el-table-column>
            </el-table>
<!--            <div style="margin-top: 3px;">-->
<!--              <el-pagination-->
<!--                @size-change="handleSizeChange2"-->
<!--                @current-change="handleCurrentChange2"-->
<!--                :current-page="currentPage2"-->
<!--                :page-sizes="[10, 20, 30, 50]"-->
<!--                :page-size="pageSize2"-->
<!--                layout="total, sizes, prev, pager, next, jumper"-->
<!--                :total="pageTotal2">-->
<!--              </el-pagination>-->
<!--            </div>-->
          </el-card>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      userName:'',
      orgId: '',
      userId:'',
      authorities:'',
      filterText:'',
      orgList:[],
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      purchase:{
        id:'',
        purchaseDate:'',
        productNo:'',
        purchaseNo:'',
        purchaseMoney:'',
        sender:'',
        inOrgId:'',
        outOrgId:'',
        orgName:'',
        state:'',
        creator:'',
        senderName:'',
        consumptions:[],
        orgIds:[]
      },
      productDrawerVisible:false,
      consumptionTypeList:[],
      consumptionTypeFilterText:'',
      consumptionTypeProps:{
        label: 'consumptionTypeName',
        children: 'children'
      },
      consumptionList:[],
      consumptionShowList:[],
      selectProductList:[],
      currentOrgPurchaseLevel:'',
      queryProductText:'',
      consumptionTypeId:'',
      productList:[],
      consumptionRequest:{
        orgId:'',
        typeId:'',
        dateType:'',
        pageNum:'',
        pageSize:'',
        queryText:'',
        productTypeId:'',
        consumptionId:''
      },
      shopList:[],
    }
  },
  methods:{
    closeSendPage(){
      this.$router.go(-1)
    },
    async handleCheckChange() {
      this.purchase.orgIds = this.$refs.tree.getCheckedKeys();
      // let shopList = this.orgList.children;
      this.shopList.map((item)=>{
        if(item.id == this.purchase.orgIds[0]){
          this.currentOrgPurchaseLevel = item.purchaseLevel;
        }
      })
    },
    // async handleNodeClick(data) {
    //   this.selectedAreaId = data.id;
    // },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //显示产品列表页面
    showProductDrawer(){
      //如果没有选择接收机构，返回。

        this.loadProductTypeList();
        this.productDrawerVisible = true;

    },
    closeProductDrawer(){
      this.getTotal();
      this.productDrawerVisible = false;
    },
    deleteConsumptionShowList(index,rows){
      rows.splice(index, 1);
      this.getTotal();
    },
    //选中产品分类加载产品的方法
    consumptionTypeHandleNodeClick(data){
      this.consumptionTypeId = data.consumptionTypeId;
      this.type = data.type;
      this.loadProductList();
    },
    //关键字查询产品的方法
    queryConsumption(){
      this.loadProductList();
    },
    async loadProductList(){
      await this.loadProductTotal();
      await this.loadProducts();
    },
    async loadProductTotal(){
      let text = 'null';
      if (this.consumptionQueryText !== ''){
        text = this.consumptionQueryText;
      }
      // this.consumptionRequest.dateType = this.type;
      this.consumptionRequest.productTypeId = this.consumptionTypeId;
      this.consumptionRequest.pageNum = this.currentPage1;
      this.consumptionRequest.pageSize = this.pageSize1;
      this.consumptionRequest.orgId = this.currentOrgId;
      this.consumptionRequest.queryText = 'null';
      const {data:res} = await this.$http.post(`/load/count/consumption/apply`, this.consumptionRequest)
      this.pageTotal2 = res.totalPage;
    },
    async loadProducts(){
      let text = 'null';
      if (this.consumptionQueryText !== ''){
        text = this.consumptionQueryText;
      }
      this.consumptionRequest.productTypeId = this.consumptionTypeId;
      this.consumptionRequest.pageNum = 1;
      this.consumptionRequest.pageSize = 9999;
      this.consumptionRequest.orgId = this.currentOrgId;
      this.consumptionRequest.queryText = 'null';
      const {data:res} = await this.$http.post(`/load/list/consumption/apply`, this.consumptionRequest)
      this.consumptionList = res.data;
    },
    consumptionTypeFilterNode(value, data){
      if (!value) return true;
      return data.consumptionTypeName.indexOf(value) !== -1;
    },
    orderNumHandleChange(value){
      let result = true;
      for (let i = 0; i < this.selectProductList.length; i++) {
        if (this.selectProductList[i].productId === value.productId && value.num > 0){
          this.selectProductList[i].num = value.num;
          result = false;
        }

        if (this.selectProductList[i].productId === value.productId && value.num === 0){
          this.selectProductList.splice(i,1);
          result = false;
        }
      }
      if (result){
        this.selectProductList.push(value);
      }
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.loadProductList();
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.loadProductList();
    },
    async loadOrg(){
      const {data:res} = await this.$http.get(`/orgs/areaList/orgId/${this.currentOrgId}`);
      this.orgList = [res.data];
      this.shopList = res.data.children;
    },
    //选择机构
    // getShop(data){
    //   this.purchase.inOrgId = data;
    //   for (let i = 0; i < this.shop.length; i++) {
    //     if (this.shop[i].id === data){
    //       this.currentOrgPurchaseLevel = this.shop[i].purchaseLevel;
    //     }
    //   }
    // },
    //加载产品分类
    async loadProductTypeList(){
      this.consumptionList = [];
      const {data:res} = await this.$http.get(`/consumptionType/purchase/orgId/${this.currentOrgId}`)
      this.consumptionTypeList = res.data;
    },
    getTotal(){
      let purchaseMoney = 0;
      for (let i = 0; i < this.selectProductList.length; i++) {
        if((this.currentOrgPurchaseLevel-0) === 1){
          purchaseMoney += this.selectProductList[i].oneLevelPrice * this.selectProductList[i].num;
        }
        if((this.currentOrgPurchaseLevel-0) === 2){
          purchaseMoney += this.selectProductList[i].twoLevelPrice * this.selectProductList[i].num;
        }
        if ((this.currentOrgPurchaseLevel-0) === 3){
          purchaseMoney += this.selectProductList[i].threeLevelPrice * this.selectProductList[i].num;
        }
      }
      this.purchase.purchaseMoney = purchaseMoney;
    },
    async createSend(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      if(this.purchase.orgIds.length == 0){
        this.$message.warning("请选择机构");
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }
      if (this.selectProductList.length === 0){
        this.$message.warning("请选择产品！")
        this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
        return;
      }

      this.purchase.sender = this.userId;
      this.purchase.creator = this.userId;
      this.purchase.outOrgId = this.currentOrgId;
      this.purchase.consumptions = this.selectProductList;
      this.purchase.orgPurchaseLevel = this.currentOrgPurchaseLevel;
      const {data:res} = await this.$http.post(`/send/add`, this.purchase);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeSendPage();
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.currentOrgPurchaseLevel = window.sessionStorage.getItem("currentOrgPurchaseLevel");
    this.orgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 200px;
}
.left_inner_con{
  width: 300px;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 75%;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/NewSendPurchase.vue